import React from 'react';
import { Table, Modal, Button, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';
import profileImg from "../../../common/images/userPrfImg-rmbg.png";

export const UserDetailModal = ({ show, onHide, resultdata, roleKeyVal, roleKey }) => {
  let entitiesArr = resultdata?.entities;
  let userRole = resultdata?.roleKey;
  if(entitiesArr) {
      console.log('entitiesArr1', entitiesArr[0].name);
  }

  if(userRole === 'employee') {
      userRole = 'Employee';
  }

  if(userRole === 'bunk_incharge') {
      userRole = 'Bunk Incharge';
  }

  return (
    <Modal role="dialog" className='view-detail-popup' dialogClassName="right-slide-modal" size='lg' show={show} backdrop centered={false} >
      <div className="modal-content">
        <button type="button" onClick={onHide} className="btn-close position-absolute end-0 top-0 m-3"></button>
        <ModalHeader>{(roleKeyVal === 'bunk_incharge' || roleKey === 'employee')?"Employee":"User"} Details</ModalHeader>
        <ModalBody>
          <div className="model-bodey-maindiv">
              <div className='profileimg-main'>
                    <div className='profileimgdiv'>
                          <div className='profileimg'>
                            <img src={(resultdata?.profileImage)?resultdata?.profileImage:profileImg} alt='profileImg' />
                          </div>
                    </div>
                    <div className='profile-title-main'>
                          <span>{userRole}</span>
                          <h4>{resultdata.firstName} {resultdata.lastName}</h4>
                    </div>
              </div>

              <div className='profile-info-main'>
                    <h6 className='modalview-info-title'>Personal Information</h6>
                    <div className='modalview-info-maindiv'>
                      <div className='modalview-info-row'>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Gender</div>
                                  <div className='modalview-info-val'>{resultdata.gender}</div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Contact Number</div>
                                  <div className='modalview-info-val'>{resultdata.phone}</div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Email</div>
                                  <div className='modalview-info-val'>{resultdata.email}</div>
                            </div>
                      </div>
                    </div>
              </div>

              {(entitiesArr) && <div className='assignment-info-main'>
                    <h6 className='modalview-info-title'>Assignment</h6>
                    <div className='modalview-info-maindiv'>
                      <div className='modalview-info-row-snglcol'>
                        <div className='modalview-info-col assignment-info-col1'>
                                <div className='modalview-info-lable'>Bunk Name</div>
                                <div className='modalview-info-val'>{entitiesArr[0]?.name}</div>
                          </div>
                        </div>  
                        <div className='modalview-info-row-snglcol'>   
                          <div className='modalview-info-col'>
                                <div className='modalview-info-lable'>Bunk Location</div>
                                <div className='modalview-info-val'>{entitiesArr[0]?.address1}, {entitiesArr[0]?.address2}, {entitiesArr[0]?.district}, {entitiesArr[0]?.state} - {entitiesArr[0]?.pincode}</div>
                          </div>
                      </div>
                    </div>
              </div>}

          </div>    
        </ModalBody>
      </div>
    </Modal>
  );
};

